module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "filter-header",
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h3', [_vm._v("Last submissions")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right sort-container",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Reservations'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    }
  }, [_vm._v("Reservations dashboard")])], 1)], 1)], 1), _vm._v(" "), _c('unreaded-submissions-list'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": (_vm.editedItem && _vm.editedItem._id) ? 'Form settings' : 'Create new form',
      "visible": _vm.showCreateForm
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateForm = $event
      }
    }
  }, [_c('settings-dialog', {
    attrs: {
      "item": _vm.editedItem
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ad2f4e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Dashboard.vue
// module id = 400
// module chunks = 4